module.exports = __webpack_public_path__ + "static/media/team2.f59d2412.webp";